// extracted by mini-css-extract-plugin
module.exports = {"background":"_base-hero-background_background_3cbag","image":"_base-hero-background_image_3-vm2"};